import { CouponEligibilityRule, Statuses } from "@/constant";

export enum DiscountType {
  FIXED_AMOUNT = 1,
  PERCENTAGE = 2,
}

export enum FrequencyType {
  ONCE = 1,
  DAILY = 2,
  WEEKLY = 3,
  MONTHLY = 4,
}

export interface IPromoData {
  id: string;
  name: string;
  code: string;
  start_date: string;
  end_date: string;
  coupon_type?: number;
  discount_amount?: number;
  discount_percentage?: number;
  max_discount?: number;
  discount_type: DiscountType;
  min_order_value: number;
  total_quantity?: number;
  remaining_usage_count?: number;
  frequency?: FrequencyType;
  customer_usage_limit?: number;
  description?: string;
  is_restricted_to_groups: boolean;
  is_supplier_promotion: boolean;
  is_hidden?: boolean;
  eligibility_rule?: CouponEligibilityRule;
  linked_club_id?: string | null;
  status: Statuses;
  created_at?: string;
  updated_at?: string;
}

export interface IPromoById {
  data: IPromoData;
}

export interface PromoResponse {
  status: boolean;
  message: string;
  data: {
    id: string;
    name: string;
    code: string;
    start_date: string;
    end_date: string;
    coupon_type?: number;
    discount_amount?: number;
    discount_percentage?: number;
    max_discount?: number;
    discount_type: DiscountType;
    min_order_value: number;
    total_quantity?: number;
    remaining_usage_count?: number;
    frequency?: FrequencyType;
    customer_usage_limit?: number;
    description?: string;
    is_restricted_to_groups: boolean;
    is_supplier_promotion: boolean;
    is_hidden?: boolean;
    eligibility_rule?: CouponEligibilityRule;
    linked_club_id?: string;
    status: Statuses;
    created_at?: string;
    updated_at?: string;
  };
}

export interface PromoListQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: Statuses;
  discount_type?: DiscountType;
  is_supplier_promotion?: boolean;
  is_restricted_to_groups?: boolean;
}

export interface UpdatePromoStatusPayload {
  promoId: string;
  status: Statuses;
}
